import React from "react"
import HeaderSection from "@components/Site/IndexPage/Windows/HeaderSection"
import TypewriterSection from "@components/Site/TypewriterSection"
import FeaturesAndBenefits from "@components/Site/Features/FeaturesAndBenefits"
import TestimonialsSection from "@components/Site/TestimonialsSection"
import HomeFeatureCardsSection from "@components/Site/HomeFeatureCardsSection"
import OrganizedBanner from "@components/Site/OrganizedBanner"
import Faq from "@components/Site/Faq"
import BubblesBg from "@components/Site/BubblesBg/BubblesBg"
import NewsletterSubscribeSection from "@components/Site/NewsletterSubscribeSection"
import LatestBlogArticlesSection from "@components/Site/LatestBlogArticlesSection"

const WindowsHome = () => {

  return (
    <div className="overflow-hidden">
      <HeaderSection />
      <TypewriterSection />
      <HomeFeatureCardsSection />
      <FeaturesAndBenefits />
      <TestimonialsSection />
      <OrganizedBanner />
      <Faq />
      <LatestBlogArticlesSection />
      <NewsletterSubscribeSection />
      <BubblesBg />
    </div>
  )
}

export default WindowsHome